<script lang="ts">
    interface Props {
        variationId: string;
        ignoreOnex?: boolean;
    }

    let { variationId, ignoreOnex = false }: Props = $props();
</script>

<div class="reptile-wishlist-icon">
    <ofc-wishlist-save-button-v1
        variation-id={variationId}
        qualified="false"
        source="ProductList"
        ignore-onex={ignoreOnex || undefined}
    ></ofc-wishlist-save-button-v1>
</div>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';

    .reptile-wishlist-icon {
        /*                                                                                */
        /*                                                                           */
        /*                                                                                    */
        pointer-events: auto;

        position: absolute;
        z-index: 1;
        top: tokens.$oc-semantic-spacing-absolute-25;
        right: tokens.$oc-semantic-spacing-absolute-25;
    }
</style>
